import React, { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import context from '../../context/product/context';

const BrandLogo: React.FC<{ className?: string }> = ({ className }) => {
	const ctxt = useContext(context);
	const data = useStaticQuery(
		graphql`
			{
				file(dir: { regex: "/brand-logo/" }) {
					childImageSharp {
						gatsbyImageData(height: 96, placeholder: NONE)
					}
				}
			}
		`
	);

	if (!data.file) {
		console.warn('Brand logo not found');
	}

	return (
		<>
			{data.file && (
				<GatsbyImage
					objectFit="scale-down"
					className={className}
					image={getImage(data.file)}
					alt={ctxt.json.params.brandName + ' Logo'}
					loading="eager"
				/>
			)}
		</>
	);
};

export default BrandLogo;
